import React, { lazy, Suspense } from "react";
import ParticleConfig from "../assets/ParticleConfig.json";

function ParticleEffect() {
  const Particles = lazy(() => import("react-tsparticles"));

  return (
    <Suspense fallback={<div></div>}>
      <Particles
        id="tsparticles"
        className="App-particles__container"
        options={ParticleConfig}
      />
    </Suspense>
  );
}

export default ParticleEffect;
